var map = {
	"./crystalsword.png": 40,
	"./crystalwand.png": 41,
	"./dagger.png": 42,
	"./doubleaxe.png": 43,
	"./hp-potion.png": 44,
	"./longsword.png": 45,
	"./mana-potion.png": 46,
	"./ring.png": 47,
	"./spellbook.png": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;